import { ROUTES } from "../../routing/routes";
import { CTA_SOL_TYPES } from "../../constants";

export const getIsRegistrationDiscountApplied = (currentPathname, lastCta) => {
  const isOnConfiguratorPage = currentPathname === ROUTES.CONFIG;
  const validCtaTypes = [
    CTA_SOL_TYPES.OFFER_CREATED,
    CTA_SOL_TYPES.ORDER_CREATED,
    CTA_SOL_TYPES.VEHICLE_ORDER_CONFIRMATION_BY_CUSTOMER,
    CTA_SOL_TYPES.REDIRECT_PAYMENT,
    CTA_SOL_TYPES.FINAL_ORDER_CONFIRMATION,
    CTA_SOL_TYPES.REFRESH_OFFER_DATA,
    CTA_SOL_TYPES.CONFIGURATION_SAVED_BY_USER,
    CTA_SOL_TYPES.PERSONAL_DETAILS_CONFIRMED,
  ];

  return !isOnConfiguratorPage && validCtaTypes.includes(lastCta);
};
